<ng-container *ngIf="!isLoadingQrCodes && !isLoadingLabels">
	<div class="qr-code-container" [style]="{ 'grid-template-columns': 'repeat(' + columns + ', 1fr)' }">
		<div *ngFor="let qrCode of cisWithQrCode">
			<qrcode
				class="qr-code"
				[width]="1240 / this.columns - 32"
				[qrdata]="qrCode.qrCode.toString()"
				[errorCorrectionLevel]="'M'"
				*ngIf="type === 'qrcode'">
			</qrcode>
			<!-- <ngx-barcode6
            [bc-value]="qrCode.barCode.toString()"
            [bc-display-value]="false"
            *ngIf="type === 'barcode'">
            </ngx-barcode6> -->
			<div>
				<div>
					<span *ngIf="showId == 1">{{ qrCode.id }} </span>
					<span *ngIf="showName == 1">({{ qrCode.identification }})</span>
				</div>
				<span *ngIf="showQrCodeDecode == 1">{{ type === 'qrcode' ? qrCode.qrCode : qrCode.barCode }}</span>
			</div>
		</div>
	</div>

	<div class="config-container" *ngIf="isConfigOpen">
		<div class="dotted-input-container">
			<span>{{ labels.lbl_geral_colunas }}:</span>
			<select (change)="columns = $event.target.value">
				<option [value]="1" [selected]="columns === 1">1</option>
				<option [value]="2" [selected]="columns === 2">2</option>
				<option [value]="3" [selected]="columns === 3">3</option>
				<option [value]="4" [selected]="columns === 4" *ngIf="type === 'qrcode'">4</option>
			</select>
		</div>

		<div class="dotted-input-container">
			<span>ID</span>
			<select (change)="showId = $event.target.value">
				<option [value]="1" [selected]="showId === 1">{{ labels.lbl_geral_sim }}</option>
				<option [value]="0" [selected]="showId === 0">{{ labels.lbl_geral_nao }}</option>
			</select>
		</div>

		<div class="dotted-input-container">
			<span>{{ labels.lbl_geral_identificacao }}</span>
			<select (change)="showName = $event.target.value">
				<option [value]="1" [selected]="showName === 1">{{ labels.lbl_geral_sim }}</option>
				<option [value]="0" [selected]="showName === 0">{{ labels.lbl_geral_nao }}</option>
			</select>
		</div>

		<div class="dotted-input-container">
			<span>{{ labels.lbl_geral_informacoes + ' ' + labels.lbl_geral_qrcode }}:</span>
			<select (change)="showQrCodeDecode = $event.target.value">
				<option [value]="1" [selected]="showQrCodeDecode === 1">{{ labels.lbl_geral_sim }}</option>
				<option [value]="0" [selected]="showQrCodeDecode === 0">{{ labels.lbl_geral_nao }}</option>
			</select>
		</div>

		<div class="button-container">
			<div class="button" (click)="isConfigOpen = false">{{ labels.lbl_geral_fechar }}</div>
			<div class="button" (click)="print()">{{ labels.lbl_geral_imprimir }}</div>
		</div>
	</div>

	<div class="wrench-blob" (click)="isConfigOpen = !isConfigOpen">
		<fa-icon [icon]="isConfigOpen ? icons.faTimes : icons.faWrench"></fa-icon>
	</div>

	<div class="print-blob" (click)="print()">
		<fa-icon [icon]="icons.faPrint"></fa-icon>
	</div>
</ng-container>
